define('model/geocode/geocode',['../selector'], function (selector) {
    "use strict";
    return function (json) {
        return selector(json, "results", "address, position, score, type, addressRanges, boundingBox") || {};
    };
});
